import { request } from "@shared/utils";
import { API, METHODS } from "@shared/constants";
import { PropertiesFilter } from "@shared/interfaces";

export default {
  getProperties: (payload: PropertiesFilter) =>
    request(METHODS.GET, API.PROPERTIES.GET_PROPERTIES)({ params: payload }),
  getPropertiesCsv: (payload: PropertiesFilter) =>
    request(METHODS.GET, API.PROPERTIES.GET_PROPERTIES_CSV)({ responseType: "blob", params: payload }),
  getProperty: (id: number) => request(METHODS.GET, API.PROPERTIES.GET_PROPERTY(id))(),
  checkIfPropertyCouldBeAssignedToLead: (id: number) =>
    request(METHODS.GET, API.PROPERTIES.CHECK_IF_PROPERTY_COULD_BE_ASSIGNED_TO_LEAD(id))(),
  assignedToLead: (body: { propertyId: number; leadId: number }) =>
    request(METHODS.POST, API.PROPERTIES.ASSIGNED_TO_LEAD)(body),
};
